<template>
  <div>
    <div class="article-firework-embedded container">
      <!-- <div class="article-firework-embedded-wrapper">
        <h2>Stories</h2>
        <fw-embed-feed
          channel="bandwagon"
          playlist="o88O1o"
          mode="grid"
          open_in="default"
          max_videos="8"
          paginate_by="4"
          placement="middle"
          player_placement="bottom-right"
          title=""
          branding="false"
        ></fw-embed-feed>
      </div> -->
      <!--
      <fw-embed-feed
        channel="bandwagon"
        playlist="ojGAKg"
        mode="row"
        open_in="default"
        max_videos="0"
        placement="middle"
        player_placement="bottom-right"
        autoplay="true"
        branding="false"
      ></fw-embed-feed>
      -->
    </div> 
    <div class="article-related-items container">
      <h2 v-if="gigs.length > 0" class="article-related-items__title">
        Upcoming Events
      </h2>
      <GigComponent v-for="gig in gigs" :key="gig.id" :gig="gig" />
      <FeaturedVideoComponent />
      <h2 v-if="articles.length > 0" class="article-related-items__title">
        Related Articles
      </h2>
      <ArticleBlockComponent
        v-for="article in articles"
        :key="article.id"
        :article="article"
        :fixed-style="'half-horizontal'"
      />
    </div>
    <div class="vue__article-playlist" style="max-width: 100%;">
      <template v-for="article in articlePlaylist">
        <hr class="article-divider" />

        <ArticleComponent
          v-if="!skipQuery"
          :key="article.id"
          :article="article"
          :sidebar-ad="advert"
          :country-newsletter-id="countryNewsletterId"
          :locale="locale"
        />
      </template>
    </div>
    <div class="next-article-loader">
      <div class="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import gql from "graphql-tag";

import GigComponent from "../gig/GigComponent.vue";
import FeaturedVideoComponent from "../video/FeaturedVideoComponent.vue";
import ArticleComponent from "./ArticleComponent.vue";
import ArticleBlockComponent from "./ArticleBlockComponent.vue";

export default {
  components: {
    GigComponent,
    FeaturedVideoComponent,
    ArticleComponent,
    ArticleBlockComponent,
  },
  props: {
    articleId: {
      type: String,
      default: "0",
    },
    articleSlug: {
      type: String,
      default: "",
    },
    fromDate: {
      type: String,
      default: () => new Date().toISOString(),
    },
  },
  apollo: {
    information: {
      query: gql`
        query visitorInformation {
          visitorInformation {
            country
            locale
            countryNewsletterId
          }
        }
      `,
      update(data) {
        this.country = data.visitorInformation.country;
        this.locale = data.visitorInformation.locale;
        this.countryNewsletterId = data.visitorInformation.countryNewsletterId;
        return data.visitorInformation;
      },
    },
    articles: {
      query: gql`
        query getRelatedArticles($country: String!, $id: String!) {
          relatedArticles(country: $country, id: $id) {
            image
            homePageImage
            title
            slug
            url
            spins
            genre
          }
        }
      `,
      variables() {
        return {
          id: this.articleId,
          country: this.country,
        };
      },
      update(data) {
        return data.relatedArticles;
      },
      skip() {
        return this.skipOnFirstLoad || this.skipQuery;
      },
    },
    adverts: {
      query: gql`
        query advertQuery($country: String!, $slot: String!, $track: Boolean!) {
          adverts(country: $country, slot: $slot, track: $track) {
            imageUrl
            url
            message
          }
        }
      `,
      variables() {
        return {
          country: this.country,
          slot: "article_sidebar",
          track: this.$isDesktop,
        };
      },
      skip() {
        return !this.$isDesktop || this.skipQuery;
      },
    },
    articlePlaylist: {
      query: gql`
        query articlePlaylist(
          $articleId: ID!
          $country: String!
          $locale: String!
          $limit: Int!
          $offset: Int!
        ) {
          articlePlaylist(
            articleId: $articleId
            country: $country
            locale: $locale
            limit: $limit
            offset: $offset
          ) {
            id
            slug
            title
            image
            coverImage
            author
            hasBrandedContentCategory
            publishedAt
            spins
            audioUrl
            likesCount
            isAllowReact
            audioActive
            content(country: $country)
            categories {
              id
              name
            }
            languageVersions {
              id
              language
            }
          }
        }
      `,
      variables() {
        return {
          articleId: this.articleId,
          country: this.country,
          locale: this.locale,
          limit: 1,
          offset: 0,
        };
      },
      skip() {
        return this.skipOnFirstLoad || this.skipQuery;
      },
    },
    gigs: {
      query: gql`
        query articleGigsQuery($id: String!, $fromDate: ISO8601DateTime!) {
          articleGigs(id: $id, fromDate: $fromDate) {
            id
            title
            startsAt
            imageUrl
            venueName
            pricing
            genres
            pick
            url
          }
        }
      `,
      variables() {
        return {
          id: this.articleId,
          fromDate: this.fromDate,
        };
      },
      update(data) {
        return data.articleGigs;
      },
      skip() {
        return this.skipOnFirstLoad;
      },
    },
  },
  data() {
    return {
      gigs: [],
      articles: [],
      articlePlaylist: [],
      articlePlaylistBreakpoints: {},
      articlePlaylistCurrentPosition: 0,
      articlePlaylistScrolled: [],
      articlePlayListOffset: 0,
      advert: {},
      adverts: [],
      advertIndex: 0,
      skipQuery: true,
      skipOnFirstLoad: true,
      country: null,
      locale: "en",
      countryNewsletterId: "c04c8e2b7e",
    };
  },
  beforeMount() {
    window.addEventListener("scroll", _.throttle(this.handleScroll, 500));
  },
  updated() {
    this.$nextTick(() => {
      this.updateLastArticlePosition();

      if ($(".article:last .audio-player-container").length > 0) {
        // Check audio exists
        this.controlAudio();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", _.throttle(this.handleScroll, 500));
  },
  methods: {
    articlesQuery() {
      this.$apollo.queries.relatedArticles.refetch();
    },
    articlePlaylistQuery() {
      this.$apollo.queries.articlePlaylist.refetch();
    },
    advertsQuery() {
      this.$apollo.queries.adverts.refetch();
    },
    updateLastArticlePosition: function() {
      // Get last article in playlist
      const lastArticle =
        document.querySelector(
          ".vue__article-playlist > .article:last-child"
        ) || document.querySelector("article.article");
      if (!lastArticle) return;

      // Get bottom bound of last article in playlist
      const bounds = lastArticle.getBoundingClientRect();

      // Set breakpoints for URL updating
      const scrollThreshold = this.articlePlaylist.length > 1 ? 200 : 100;
      this.articlePlaylistBreakpoints[this.articlePlaylist.length] =
        this.articlePlaylistBreakpoints[this.articlePlaylist.length] ||
        bounds.top + window.scrollY - scrollThreshold;
    },

    handleScroll() {
      if (
        $(window).scrollTop() + $(window).height() >=
        $(document).height() * 0.75
      )
        this.loadNextArticle();

      if (
        window.scrollY >=
        this.articlePlaylistBreakpoints[this.articlePlaylistCurrentPosition + 1]
      ) {
        this.articlePlaylistCurrentPosition += 1;
      }

      if (
        window.scrollY <
        this.articlePlaylistBreakpoints[this.articlePlaylistCurrentPosition]
      ) {
        this.articlePlaylistCurrentPosition -= 1;
      }
    },

    loadNextArticle() {
      this.skipOnFirstLoad = false;
      this.articlePlayListOffset += 1;

      // Load more articles
      this.$apollo.queries.articlePlaylist.fetchMore({
        // Update query with new variables
        variables: {
          articleId: this.articleId,
          country: this.country,
          locale: this.locale,
          limit: 1,
          offset: this.articlePlayListOffset,
        },
        // Add new data to existing data
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return previousResult;

          return {
            articlePlaylist: [
              ...previousResult.articlePlaylist,
              ...fetchMoreResult.articlePlaylist,
            ],
          };
        },
      });
    },

    controlAudio() {
      const lengthAudio = $(".audio-player-container").length;
      const container = document.querySelectorAll(".audio-player-wrap")[
        lengthAudio - 1
      ];
      const audio = document.querySelectorAll(".audio-src")[lengthAudio - 1];
      const seekSlider = document.querySelectorAll(".seek-slider")[
        lengthAudio - 1
      ];
      const playBtn = document.querySelectorAll(".play-btn")[lengthAudio - 1];
      const playBtnMobile = document.querySelectorAll(".play-btn-mobile")[
        lengthAudio - 1
      ];
      const totalTime = document.querySelectorAll(".total-time")[
        lengthAudio - 1
      ];

      audio.addEventListener("loadedmetadata", () => {
        totalTime.innerText = timeConvert(audio.duration);
      });

      audio.addEventListener("ended", function() {
        playBtnMobile.children[0].classList.toggle("fa-pause");
        playBtnMobile.children[0].classList.toggle("fa-play");

        playBtn.children[0].classList.toggle("fa-pause");
        playBtn.children[0].classList.toggle("fa-play");
        container.classList.toggle("show");
      });

      const setCurrentTime = (currentTime) => {
        audio.currentTime = currentTime;
      };

      const getAudioProgress = (currentTime) => {
        const progress = (currentTime / audio.duration) * 100;
        seekSlider.value = progress;
        return progress;
      };

      const timeConvert = (time) => {
        if (!time) return null;

        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        const secondsFormat = seconds < 10 ? `0${seconds}` : seconds;

        return `${minutes}:${secondsFormat}`;
      };

      const markSlider = (value, slider) => {
        slider.style.background =
          "linear-gradient(to right, #E64326 0%, #E64326 " +
          value +
          "%, #aaa " +
          value +
          "%, #aaa 100%)";
      };

      const playAudio = (button) => {
        if (container.className.includes("show")) {
          audio.pause();
        } else {
          audio.play();
        }
        button.children[0].classList.toggle("fa-pause");
        button.children[0].classList.toggle("fa-play");
        container.classList.toggle("show");
      };

      audio.addEventListener("timeupdate", (e) => {
        const currentTime = e.target.currentTime;
        getAudioProgress(currentTime);
        markSlider((currentTime * 100) / audio.duration, seekSlider);
      });

      seekSlider.addEventListener("input", (e) => {
        const progress = parseInt(e.target.value);
        const time = (progress / 100) * audio.duration;
        setCurrentTime(time);
        getAudioProgress(time, audio.duration);
      });

      if (window.innerWidth > 768) {
        const volumeSlider = document.querySelectorAll(".volume-slider")[
          lengthAudio - 1
        ];
        const muteBtn = document.querySelectorAll(".mute-btn")[lengthAudio - 1];

        const muteAudio = () => {
          if (audio.muted) {
            audio.muted = false;
          } else {
            audio.muted = true;
          }
          muteBtn.children[0].classList.toggle("fa-volume-up");
          muteBtn.children[0].classList.toggle("fa-volume-mute");
        };

        playBtn.onclick = () => {
          playAudio(playBtn);
        };

        muteBtn.onclick = () => {
          muteAudio();
        };

        volumeSlider.addEventListener("input", (e) => {
          const value = e.target.value;
          const volume = value / 100;
          audio.volume = volume;
          markSlider(value, e.target);
        });
      } else {
        const forwardBtn = document.querySelectorAll(".forward-btn")[
          lengthAudio - 1
        ];
        const rewindBtn = document.querySelectorAll(".rewind-btn")[
          lengthAudio - 1
        ];
        playBtnMobile.onclick = () => {
          playAudio(playBtnMobile);
        };

        forwardBtn.onclick = () => {
          audio.currentTime += 15;
        };

        rewindBtn.onclick = () => {
          audio.currentTime -= 15;
        };
      }
    },
  },
  watch: {
    country: function(val, oldVal) {
      if (oldVal == null && val != null) {
        this.skipQuery = false;
        this.articlesQuery();
        this.articlePlaylistQuery();
        this.advertsQuery();
      }
    },
    adverts(adverts) {
      // eslint-disable-next-line
      this.advertIndex = ~~(adverts.length * Math.random());
      this.advert = adverts[this.advertIndex];
    },
    articlePlaylistCurrentPosition(newPosition, _oldPosition) {
      let newUrl = "/articles/";

      if (newPosition > 0) {
        let slug = this.articlePlaylist[newPosition - 1].slug;
        newUrl += slug;

        if (!this.articlePlaylistScrolled.includes(slug)) {
          $.ajax({
            type: "POST",
            url: `/articles/${slug}/increase_visit`,
            data: {
              slug: slug,
            },
            dataType: "json",
          });
          this.articlePlaylistScrolled.push(slug);
        }
      } else {
        newUrl += this.articleSlug;
      }
      this.advertIndex += 1;
      if (this.advertIndex >= this.adverts.length) {
        this.advertIndex = 0;
      }

      this.advert = this.adverts[this.advertIndex];
      window.history.replaceState({}, "", newUrl);
    },
    articlePlaylist(articles) {
      twttr.widgets.load();
      window.instgrm.Embeds.process();
      if (articles.length > 1) {
        (adsbygoogle = window.adsbygoogle || []).push({});
      }
    },
  },
};
</script>
